import { apiClient } from "@/services/apiClient";

export type SiteSelectedEnvironment = "Dev" | "Test" | "Prod";
export type SiteSelectedPermission = "Read" | "Write" | "Manage" | "FullControl";

export interface SiteSelectedProvisionRequest {
  siteId: string;
  siteUrl: string;
  siteTitle: string;
  groupId: string;
  environments: SiteSelectedEnvironment[];
  permission: SiteSelectedPermission;
  purpose?: string;
  justification: string;
  ownerObjectIds: string[];
  test: boolean;
  debug: boolean;
  debugLevel: number;
}

export interface SiteSelectedOwnerResult {
  ownerObjectId: string;
  status: string;
  error?: string;
}

export interface SiteSelectedEnvironmentResult {
  environment: string;
  displayName: string;
  permission: string;
  appId?: string;
  applicationObjectId?: string;
  adminConsentStatus: string;
  siteGrantStatus: string;
  status: string;
  entraReviewUrl?: string;
  adminConsentUrl?: string;
  error?: string;
  owners: SiteSelectedOwnerResult[];
}

export interface SiteSelectedProvisionResponse {
  requestGuid: string;
  status: string;
  succeeded: boolean;
  rolledBack: boolean;
  failureReason?: string;
  environments: SiteSelectedEnvironmentResult[];
}

export interface SiteSelectedRequestSummary {
  requestGuid: string;
  siteId: string;
  siteUrl: string;
  siteTitle: string;
  groupId: string;
  permission: string;
  purpose?: string;
  justification: string;
  createdBy: string;
  requestStatus: string;
  createDt: string;
  lastUpdateDt: string;
  failureReason?: string;
}

export interface SiteSelectedEvent {
  eventGuid: string;
  requestGuid: string;
  environment?: string;
  eventType: string;
  severity: string;
  message: string;
  graphRequestId?: string;
  payloadJson?: string;
  createDt: string;
}

export async function provisionSiteSelectedAccess(
  payload: SiteSelectedProvisionRequest
): Promise<SiteSelectedProvisionResponse> {
  const res = await apiClient.post<SiteSelectedProvisionResponse>(
    "/api/admin/site-selected/provision",
    payload
  );
  return res.data;
}

export async function getSiteSelectedRequests(): Promise<SiteSelectedRequestSummary[]> {
  const res = await apiClient.get<SiteSelectedRequestSummary[]>(
    "/api/admin/site-selected/requests"
  );
  return res.data;
}

export async function getSiteSelectedEvents(
  requestGuid: string
): Promise<SiteSelectedEvent[]> {
  const res = await apiClient.get<SiteSelectedEvent[]>(
    `/api/admin/site-selected/requests/${requestGuid}/events`
  );
  return res.data;
}
